import store from 'app-store';
import { SET } from './action-types';

// Action creators
export function set(data) {
  store.dispatch({
    type: SET,
    data
  });
}
